export default class extends HTMLElement {
  connectedCallback () {
    this.anchorLinks.forEach(link => {
      link.addEventListener('click', this.onAnchorClick)
    })
  }

  disconnectedCallback () {
    this.anchorLinks.forEach(link => {
      link.removeEventListener('click', this.onAnchorClick)
    })
  }

  onAnchorClick (event) {
    event.preventDefault()

    const anchorId = this.hash
    const anchorElement = document.querySelector(anchorId)

    if (anchorElement) {
      anchorElement.scrollIntoView()

      const url = new URL(window.location.href)
      url.hash = anchorId

      window.history.replaceState({}, '', url)
    }
  }

  get anchorLinks () {
    return document.querySelectorAll('a[href^="#"]')
  }
}
